import { Checkbox } from "components/DesignSystem/Checkbox/Checkbox";
import { DateInput } from "components/DesignSystem/DateInput/DateInput";
import classNames from "classnames";
import dayjs from "dayjs";
import { ChangeEvent } from "react";
import {
  Field,
  FieldProps,
  FormikValues,
  getIn,
  useFormikContext,
} from "formik";
import { DISPLAY_DATE } from "constants/date";

export const RoleAppointmentFields = ({
  namePrefix,
}: {
  namePrefix: string;
}) => {
  const { values, setFieldValue } = useFormikContext<FormikValues>();
  const startDate = getIn(values, `${namePrefix}.startDate`);
  const endDate = getIn(values, `${namePrefix}.endDate`);
  const currentlyHolds = getIn(values, `${namePrefix}.currentlyHolds`);
  const endDateError =
    startDate && endDate && dayjs(endDate).isBefore(dayjs(startDate), "day")
      ? "End date cannot be before the start date"
      : "";

  const handleCurrentlyHoldsChange = (e: ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setFieldValue(`${namePrefix}.currentlyHolds`, checked);
    if (checked) {
      setFieldValue(`${namePrefix}.endDate`, "");
    }
  };

  return (
    <>
      <div
        className={classNames("t-grid t-gap-3", {
          "t-grid-cols-2": !currentlyHolds,
          "t-grid-cols-1": currentlyHolds,
        })}
      >
        <Field name={`${namePrefix}.startDate`}>
          {({ field }: FieldProps) => (
            <DateInput
              {...field}
              customSize="small"
              label="Start date"
              placeholder={DISPLAY_DATE}
              portalId={`start-${namePrefix}`}
              required
            />
          )}
        </Field>
        {!currentlyHolds && (
          <Field name={`${namePrefix}.endDate`}>
            {({ field }: FieldProps) => (
              <DateInput
                {...field}
                customSize="small"
                label="End date"
                placeholder={DISPLAY_DATE}
                portalId={`end-${namePrefix}`}
                customType={endDateError ? "error" : undefined}
              />
            )}
          </Field>
        )}
      </div>
      {endDateError && (
        <span className="t-text-body-sm t-italic t-text-red-50">
          {endDateError}
        </span>
      )}
      <Checkbox
        name={`${namePrefix}.currentlyHolds`}
        label="This person currently holds this role"
        checked={currentlyHolds}
        onChange={handleCurrentlyHoldsChange}
      />
    </>
  );
};
